import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c559c192"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm bg-white drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "open_with")
], -1))
const _hoisted_3 = { class: "dp-column-icons d-flex flex-column align-items-end" }
const _hoisted_4 = ["data-dp-tooltip"]
const _hoisted_5 = ["data-bs-title"]
const _hoisted_6 = ["src", "alt", "title"]
const _hoisted_7 = {
  key: 0,
  class: "dp-column-preview-container bg-white rounded-1 shadow p-2"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "fw-700"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 3,
  class: "btn btn-sm btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MetadataIcons = _resolveComponent("MetadataIcons")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'column-' + _ctx.column.id,
    class: _normalizeClass(["dp-column h-100", { 'active': _ctx.activeColumnId === _ctx.column.id, 'invisible-column': !_ctx.isVisibleColumn || _ctx.isInvisibleRow }]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activateColumn(_ctx.column.id))),
    "data-bs-toggle": "popover",
    "data-bs-trigger": "manual"
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.hasPreview)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsShowPreview(true))),
            onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIsShowPreview(false))),
            class: "dp-column-info mas text-primary ms-1 mb-1"
          }, "frame_inspect", 32))
        : _createCommentVNode("", true),
      (_ctx.hasVisibilityRule)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: "dp-column-info mas text-primary ms-1 mb-1",
            "data-dp-tooltip": _ctx.getDescriptionVisibilityRuleStatus(_ctx.column.element_metadata)
          }, _toDisplayString((_ctx.isVisibleColumn) ? 'visibility' : 'visibility_off'), 9, _hoisted_4))
        : _createCommentVNode("", true),
      (!_ctx.column.cb_in_row.cb_id)
        ? (_openBlock(), _createElementBlock("i", {
            key: 2,
            class: "dp-column-warning mas text-danger ms-1 mb-1",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "top",
            "data-bs-title": _ctx.$t('cms.incompleteColumnContent')
          }, "warning", 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createVNode(_component_MetadataIcons, {
        "custom-design-template": _ctx.column?.cd_template,
        "page-element-metadata": _ctx.column?.element_metadata,
        "icon-class": "dp-column-warning",
        "has-eyebrow": !!(_ctx.column?.cb_in_row?.eyebrow),
        "has-border": !!(_ctx.column?.cb_in_row?.border),
        "has-box-shadow": !!(_ctx.column?.cb_in_row?.box_shadow),
        "has-overlays": !!(_ctx.column?.cb_in_row?.background_image?.overlays?.length)
      }, null, 8, ["custom-design-template", "page-element-metadata", "has-eyebrow", "has-border", "has-box-shadow", "has-overlays"])
    ]),
    _createElementVNode("img", {
      src: require('@/assets/images/content-blocks/types/' + _ctx.column.cb_in_row.structure_code + '.svg'),
      class: "img-fluid",
      alt: _ctx.column.cb_in_row.structure_code,
      title: _ctx.getContentBlockStructureDescription(_ctx.column.cb_in_row.structure_code)
    }, null, 8, _hoisted_6),
    (_ctx.hasPreview)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.hasPreviewImage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["image", _ctx.hasPreviewContent ? 'col-4' : 'col'])
                }, [
                  _createElementVNode("img", {
                    src: _ctx.cbPreview.image_url,
                    alt: "CB preview",
                    class: "w-100 h-auto"
                  }, null, 8, _hoisted_9)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.hasPreviewContent)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["content text-start", _ctx.hasPreviewImage ? 'col-8' : 'col'])
                }, [
                  (_ctx.cbPreview.title)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(_ctx.cbPreview.title), 1))
                    : _createCommentVNode("", true),
                  (_ctx.cbPreviewDescription)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        innerHTML: _ctx.cbPreviewDescription,
                        class: "description mb-1"
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  (_ctx.cbPreviewContent)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        innerHTML: _ctx.cbPreviewContent,
                        class: "content mb-1"
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.cbPreview.button_text)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_13, _toDisplayString(_ctx.cbPreview.button_text), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ])
        ], 512)), [
          [_vShow, _ctx.isShowPreview]
        ])
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}